export const typography = {
  fontFamily: {
    scale: 'typography',
  },
  fontSize: {
    scale: 'typography',
  },
  fontStyle: {
    scale: true,
  },
  fontWeight: {
    scale: 'typography',
  },
  letterSpacing: {
    scale: 'typography',
  },
  lineHeight: {
    scale: 'typography',
  },
  overflowWrap: {
    scale: true,
  },
  textAlign: {
    scale: true,
  },
  textDecoration: {
    scale: true,
  },
  textIndent: {
    scale: true,
  },
  textOverflow: {
    scale: true,
  },
  textShadow: {
    scale: 'boxShadows',
  },
  textTransform: {
    scale: true,
  },
  whiteSpace: {
    scale: true,
  },
  wordBreak: {
    scale: true,
  },
} as const;
/**
 * NextJS 12.2.5 does not support `satisfies` assertion
 * Once we upgrade NextJS, these should be `as const satisfies ScaleObject`
 */

export type Typography = typeof typography;
